<app-custom-circle-icon color="principal-color">
    <span icon class="info">i</span>
</app-custom-circle-icon>
